import { PhotosType } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotosTile.types'
import { GQLPhotoFaceCenter } from 'generated-graphql/graphql'

enum Position {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
  Center = 'center',
}

export interface Props {
  $coordinates?: GQLPhotoFaceCenter | null
  width?: number
  height?: number
  $type?: PhotosType
}

/**
 * Границы области 0-33, 33-66, 66-100
 */
enum EdgePosition {
  Middle = 33,
  Right = 66,
}

const findPositionX = (position: number) => {
  if (position > EdgePosition.Right) {
    return Position.Right
  }

  if (position > EdgePosition.Middle) {
    return Position.Center
  }

  return Position.Left
}

const findPositionY = (position: number) => {
  if (position > EdgePosition.Right) {
    return Position.Bottom
  }

  if (position > EdgePosition.Middle) {
    return Position.Center
  }

  return Position.Top
}

/**
 * Матрица в рамках который определяем зону фото:
 * Надо подумать как избавится от восклицательно знака
 * |L|M|R|
 * |L|M|R|
 * |L|M|R|
 * @param props
 */
export const calculatePosition = (
  props: Props,
  percentage: boolean = false
): string => {
  if (
    props.height &&
    props.width &&
    props.$type &&
    props.$coordinates &&
    props.$coordinates[props.$type]
  ) {
    const coordinatesX =
      (props.$coordinates[props.$type]!.x * 100) / props.width
    const coordinatesY =
      (props.$coordinates[props.$type]!.y * 100) / props.height

    if (percentage && coordinatesX && coordinatesY) {
      return `${coordinatesX}% ${coordinatesY}%`
    }

    const positionX = findPositionX(coordinatesX)
    const positionY = findPositionY(coordinatesY)

    return [positionX, positionY].join(' ')
  }

  return Position.Center
}
